import { InjectionToken } from '@angular/core';
import { environment } from 'src/environments/environment';

/**
 * Chave do Assistente Izii (chat com IA) no front: `chatIaDisponivel` do
 * environment, true so no dev e no local. Decide o item do menu
 * (SharedService) e se a rota casa (chatIaDisponivelGuard). Vem por token, e
 * nao lida direto do environment, para os testes trocarem o valor.
 * O backend tem a chave dele (ChatIa:Habilitado) e responde 404 quando
 * desligado, entao ligar so aqui nao abre nada.
 */
export const CHAT_IA_DISPONIVEL = new InjectionToken<boolean>(
  'CHAT_IA_DISPONIVEL',
  {
    providedIn: 'root',
    factory: () => environment.chatIaDisponivel === true,
  }
);

/** Caminho da tela do Assistente Izii no app-routing. */
export const CAMINHO_DO_ASSISTENTE_IZII = 'assistente-izii';

/** Endereco da tela: o item do menu aponta para ele. */
export const URL_DO_ASSISTENTE_IZII = `/${CAMINHO_DO_ASSISTENTE_IZII}`;

/** Endereco antigo, de quando a tela era o Assistente de faturas (ate 23/10/2026). */
export const CAMINHO_ANTIGO_DO_ASSISTENTE = 'assistente-de-faturas';
